<template>
    <div class="privacyPage">
        <header class="mainHeader">
            <div class="mainHeader__inner">
                <img src="https://www.tcl.eu/bundles/tclapp/img/logo/tcl.svg" width="175" height="49" alt="TCL The Creative Life">
            </div>
        </header>

        <main class="mainCenter">
            <section class="stage">
                <div class="stage__bg" style="background-image: url('https://dmayeb5ar6kq1.cloudfront.net/common/5afe96406f1ca_591efa86bf9d0_COMPARATEUR.jpg')"></div>
                <div class="mainContent__center">
                    <div class="grid">
                        <div class="grid__col-6 grid__col-md-12 grid--order-0-md grid--align-center">
                            <div class="stage__text">
                                <h1 class="tl1">
                                    Aviso de Privacidade - Serviços Smart TV
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="mainContent__section">
                <div class="mainContent__center">
                    <p>
                        Nós respeitamos a sua privacidade ao tratar os seus dados pessoais. Este Aviso de Privacidade descreve a entidade responsável pelo tratamento de dados pessoais que recolhemos com referência à utilização dos nossos serviços de Smart TV ("Serviços"), que tipos de dados pessoais recolhemos sobre si, o que fazemos com eles e quais os seus direitos em relação ao nosso uso dos dados pessoais.
                    </p>
                    <h3>
                        1. Responsável pelo tratamento e representante na União Europeia
                    </h3>
                    <p>
                        A recolha, tratamento e utilização dos dados pessoais recolhidos do utilizador, ao usar os Serviços, são realizados pela Shenzhen TCL New Technology Co., Ltd., No. 5, Industrial Avenue (M), Sheko Industrial Zone, Shenzhen City, Guangdong Province, China ("Sociedade"). Os nossos detalhes de contacto, bem como os detalhes de contacto do nosso representante na União Europeia, são fornecidos na Secção 12 abaixo. Note-se, no entanto, que não somos responsáveis por todas as atividades de tratamento de dados descritas abaixo. Ainda assim, incluímos uma descrição das respetivas atividades no nosso Aviso de Privacidade, já que o tratamento em causa está relacionado com a utilização da Smart TV.
                    </p>

                    <h3>
                        2. Consentimento para o tratamento de dados
                    </h3>
                    <p>
                        Algumas das atividades de tratamento de dados que realizamos exigem o seu consentimento, como, por exemplo, a utilização dos seus dados pessoais para melhorar os Serviços.
                    </p>
                    <p>
                        O consentimento é voluntário e poderá ainda utilizar os Serviços se não consentir. No entanto, pode não ver conteúdo que seja adaptado às suas preferências. Independentemente do seu consentimento, reservamo-nos no direito de tratar os seus dados pessoais na medida permitida pela lei aplicável.
                    </p>
                    <p>
                        Pode retirar o seu consentimento a qualquer momento. A retirada do consentimento não afetará a legalidade do tratamento com base no consentimento antes deste ser retirado. Para retirar o seu consentimento e / ou opor-se (conforme Secção 10 e Anexo: Os Seus Direitos abaixo, para os seus direitos de oposição), altere as configurações de privacidade da sua Smart TV em conformidade.
                    </p>

                    <h3>
                        3. Categorias específicas de dados pessoais
                    </h3>
                    <p>
                        Procedemos ao tratamento em particular das seguintes categorias de dados:
                    </p>
                    <p>
                        ID do Dispositivo: A sua Smart TV armazena um número fixo único que nos permite identificar e autenticar a Smart TV quando usa os Serviços. Este número denomina-se ID do dispositivo.
                    </p>
                    <p>
                        Endereço IP e endereço MAC: A sua Smart TV receberá um endereço IP ao aceder à Internet. Se a sua Smart TV estiver conectada a um router (por exemplo, numa rede doméstica local ou WLAN local), poderemos proceder ao tratamento do endereço IP desse router. O endereço MAC é um número exclusivo atribuído a cada interface de rede da sua Smart TV.
                    </p>
                    <p>
                        Informações específicas do dispositivo: A Smart TV armazena várias informações sobre si própria e a sua configuração. Estas informações incluem o tipo de Smart TV, a versão do sistema operacional da Smart TV, a resolução de ecrã, a ID do projeto (ou seja, informações sobre arquivos de configuração), o agente do utilizador, o nome do navegador utilizado, a versão do navegador, bem como o idioma e país que foram configurados na Smart TV.
                    </p>
                    <p>
                        Estas informações serão utilizadas por nós e serão fornecidas ao parceiro de serviços e parceiros de conteúdo para os fins descritos abaixo.
                    </p>

                    <h3>
                        4.	Finalidades para as quais procedemos ao tratamento e / ou utilizamos os seus dados pessoais e fundamentos jurídicos
                    </h3>
                    <p>
                        As finalidades para as quais procedemos ao tratamento dos seus dados pessoais e os respetivos fundamentos jurídicos são descritas abaixo. Na medida em que a é a execução de um contrato seja mencionada abaixo como fundamento jurídico, não podemos fornecer-lhe os Serviços se não nos fornecer os respetivos dados. Na medida em que o seu consentimento seja mencionado como fundamento jurídico, o utilizador é livre para fornecer ou recusar o seu consentimento. Se não fornecer o seu consentimento, não procederemos ao tratamento dos seus dados pessoais para os motivos em causa.
                    </p>
                    <ul>
                        <li>
                            Fornecer os Serviços: Usamos o endereço IP e o endereço MAC, ID de Dispositivo, a versão do sistema operacional da Smart TV, tipo de cliente da sua Smart TV e a sua resolução de ecrã, a ID do projeto (ou seja, informações sobre arquivos de configuração), a sua lista de canais de Televisão Digital (DTV), os canais visualizados, o fuso horário, o país e as configurações de idioma para fornecer à sua Smart TV acesso aos nossos Serviços e aos serviços fornecidos pelos nossos parceiros de conteúdo. Os Motivos incluem (mas não estão limitados a) fornecer serviços baseados na sua localização (por exemplo, previsões do tempo); manuseio abusivo, gestão de incidentes de segurança, monitorização da disponibilidade dos Serviços e fornecer serviços de reserva das preferências do usuário.
                        </li>
                        <p>
                            Quando utiliza os Serviços, a sua Smart TV solicitará dados dos Serviços através da Internet. Como parte dessas solicitações, o seu endereço IP, conforme descrito acima, bem como o idioma e o país que foram configurados na sua Smart TV, serão transmitidos ao nosso parceiro de serviços. O nosso parceiro de serviços procederá ao tratamento dos respetivos dados de acordo com o seu aviso de privacidade.
                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é a execução de um contrato, nos termos do Artigo 6 (1) b) do Regulamento Geral de Proteção de Dados (“RGPD”).
                        </p>

                        <li>
                            Configurações de Serviço: Como parte do funcionamento regular dos Serviços, o utilizador pode organizar manualmente a ordem na qual as aplicações são exibidas pelos Serviços. O nosso parceiro de serviços armazenará a sua organização e outras preferências que pode definir durante o uso dos Serviços. Esta informação estará vinculada ao ID do dispositivo.
                        </li>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é é a execução de um contrato, nos termos do Artigo 6 (1) b) do RGPD.
                        </p>

                        <li>
                            Autenticação: Sempre que o utilizador conectar a sua Smart TV à Internet e ligar a Smart TV, esta conectar-se-á automaticamente aos Serviços, que são geridos pelo nosso parceiro de serviço. A sua Smart TV será então autenticada como sendo certificada para acesso aos Serviços. Para fins de autenticação, os Serviços armazenam um ou mais identificadores numéricos únicos referentes à sua Smart TV. Usamos o ID de Dispositivo e o endereço MAC para fins de autenticação. Também fornecemos o ID de dispositivo a determinados parceiros de conteúdo para fins de autenticação. Estes parceiros de conteúdo usam o ID do dispositivo para autenticar sua Smart TV, para que possa aceder aos serviços fornecidos pelo parceiro de conteúdo.
                        </li>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é é a execução de um contrato, nos termos do Artigo 6 (1) b) do RGPD.
                        </p>

                        <li>
                            Diagnóstico remoto: Como parte dos Serviços, fornecemos serviços de diagnóstico remoto. Assim, processamos o ID do dispositivo, o número do dispositivo, o número de série, o endereço MAC e os registos de erros, códigos de erros e descrições de erros, fornecidos automaticamente pelo módulo defeituoso (aplicativo, sistema de middleware).
                        </li>
                        <p>
                            Acresce que, se ligar para o nosso apoio ao cliente, dependente da sua autorização prévia, o agente de suporte técnico pode aceder remotamente à sua TV e executar serviços de diagnóstico remoto.
                            Neste caso, o agente de suporte técnico recebe acesso à sua TV e à sua rede, aplicação e ficheiros de dados arquivados, e poderá processar o ID do dispositivo, número do dispositivo, número de série, endereço MAC, registos de erros, códigos de erros, descrição de erros, ID do terminal, informação das aplicações instaladas, captura de ecrã da TV e informação de dispositivos de USB/Bluetooth conectados para avaliação do estado da TV e aplicações associadas e dados. Os registos de erros poderão conter informação, tal como histórico de programas da TV, lista de músicas tocadas, nome de utilizador e palavra-chave da aplicação, caso uma aplicação de terceiros utilizada para a transmissão não tenha encriptado tal informação. Mediante a sua solicitação, isto será realizado para diagnosticar problemas, modificar as definições do sistema ou para corrigir quaisquer problemas reportados. Mais, mediante solicitação, os membros do apoio ao cliente poderão resolver problemas, correr programas ou instalar/desinstalar software, reconfigurar e/ou realizar qualquer outro tipo de serviço ou suporte técnico na TV.

                        </p>
                        <p>
                            Qualquer acesso remoto apenas será realizado após ter ativado a função de suporte remoto ao selecionar a caixa de seleção na sua TV e irá terminar após a respetiva sessão.
                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é a execução de um contrato, nos termos do Artigo 6 (1) b) do RGPD.
                        </p>

                        <li>
                            Serviço pós-venda: De acordo com a lei aplicável, o utilizador pode ter garantia ou direitos semelhantes para obter serviços pós-venda. A TCL Europe, 9-15 rue Rouget de L'Isle-92130 Issy- Les-Moulineaux, França, é responsável pelo tratamento de pedidos de garantia e outros pedidos de serviços pós-venda, bem como pelo tratamento dos seus dados pessoais associados. Ou seja, para fins de serviços pós-venda, a TCL Europe atua como responsável pelo tratamento, pelo que não somos responsáveis pelo respetivo tratamento dos seus dados pessoais.
                        </li>
                        <p>
                            Quando o utilizador solicita o nosso serviço pós-venda, o seu nome, endereço de e-mail, número de telefone, solicitação de serviço e endereço postal incluídos na fatura podem ser necessários para fornecer o serviço pós-venda. As informações também podem ser recolhidas por meio dos parceiros de pós-venda dos nossos revendedores ou prestadores de serviços autorizados, se o utilizador ligar a fim de obter o serviço. O utilizador pode entrar em contacto com a TCL Europe sob os detalhes de contacto indicados na Seção 12 abaixo para obter mais informações sobre a proteção de dados pessoais referentes aos serviços pós-venda.
                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento é a obrigação de cumprimento de obrigações jurídicas, nos termos do Artigo 6 (1) c) do RGPD.
                        </p>

                        <li>
                            T- Channel: O T- Channel é a página principal para o uso da Smart TV no sistema operacional Linux (veja abaixo para o uso do sistema operacional Android) e permite selecionar determinado conteúdo.
                        </li>
                        <p>
                            O fundamento jurídico para o tratamento dos seus dados pessoais necessários para a sua utilização do T- Channel r, é a execução de um contrato nos termos do artigo 6.º, n.º 1, alínea b), do RGPD.
                        </p>
                        <p>
                            Sujeito ao seu consentimento prévio, procederemos também à monitorização da utilização do T- Channel, ou seja:
                            <ul>
                                <li>
                                    Quando começar a utilizar o T- Channel, gravamos a hora de entrada e saída do T-Launcher
                                </li>
                                <li>
                                    Quando começar a ver um vídeo no T- Channel, gravamos o nome e o tempo de duração do vídeo (não aplicável ao Netflix, ao YouTube, ou a qualquer outro serviço fornecido por terceiros).
                                </li>
                                <li>
                                    Ao entrar ou sair de uma página, registamos o tempo de permanência nessa página.
                                </li>
                                <li>
                                    Quando mover o cursor de um local para outro ou entrar numa aplicação, registamos esse evento.
                                </li>
                                <li>
                                    Ao instalar, remover ou atualizar aplicações, registamos esses eventos, incluindo o nome das mesmas.
                                </li>
                            </ul>
                        </p>
                        <p>
                            Recolhemos estas informações principalmente para análise de um grande conjunto de dados armazenados (big data analysis), de forma a melhorar os produtos e fornecer melhores serviços de conteúdo aos utilizadores.
                        </p>
                        <p>
                            O fundamento jurídico para o tratamento dos seus dados pessoais, em conexão com a monitorização da utilização do T- Channel, é o seu consentimento, nos termos do Artigo 6 (1) a) do RGPD.
                        </p>
                        <p>
                            Se o utilizador comprou uma Android TV e utiliza o sistema operacional Android da Google, os seus dados pessoais serão tratados pela Google, e não somos responsáveis por esse tratamento. Por favor consulte o aviso de privacidade da Google para obter informações sobre o tratamento relacionado com os seus dados e quais os seus respetivos direitos.
                        </p>

                        <li>
                            T-Cast: O T-Cast permite que o utilizador controle a sua TV através do seu telefone, e compartilhe vídeos, músicas e imagens armazenadas no seu smartphone na TV. O T-Cast também permite que o utilizador espelhe o smartphone na sua TV.
                        </li>

                        <p>
                            O descarregamento e utilização da aplicação são voluntários. Se o utilizador descarregar e usar a aplicação, trataremos o endereço MAC para calcular quantas versões de T-Cast foram utilizadas no mercado. Isto é necessário para poder oferecer o serviço. Se o utilizador usar a nossa funcionalidade de segundo ecrã, os controlos que ativar na aplicação e as configurações de país e idioma, lista de canais DTV, listas de canais favoritos, listas de agendamentos, ID do dispositivo, canal atual, versão do protocolo e endereço IP da sua Smart TV serão recolhidos e tratados por nós, nos nossos servidores. Os nossos servidores controlarão a sua Smart TV conforme indicado pelo utilizador na aplicação.
                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é a execução de um contrato, nos termos do Artigo 6 (1) b) do RGPD.
                        </p>

                        <li>
                            Assistente TCL: O Assistente TCL é uma funcionalidade que permite que a sua TV se conecte a dispositivos compatíveis com o Amazon Alexa (tais como o Echo) para controlar esse dispositivo através da sua voz. Por forma a utilizar esta função, terá, em primeiro lugar, que registar a sua TV no site da Amazon através da utilização do código TCL, que pode ser encontrado na sua TV. De seguida poderá emitir instruções verbais para o dispositivo compatível com o Amazon Alexa ao pressionar o botão do microfone do controlo remoto da sua TV.
                        </li>
                        <p>
                            Se utiliza o Assistente TCL, a sua TV irá recolher a sua voz e enviar para o Amazon Alexa, para efeitos de reconhecimento de voz e tratamento posterior. Os seus dados serão transferidos diretamente para a Amazon e nenhum dado será tratado ou armazenado localmente na sua TV.
                            Por favor consulte a política de privacidade da Amazon para mais informações relativamente ao tratamento dos seus dados por parte da Amazon.

                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é a execução de um contrato, nos termos Artigo 6 (1) b) do RGPD.
                        </p>

                        <li>
                            Alexa Voice Recognition (AVS): A AVS é uma funcionalidade que lhe permite controlar a TV através da sua voz. Por forma a utilizar esta função, terá, em primeiro lugar, que registar a sua TV no site da Amazon através do código de registo gerado pela Amazon. De seguida poderá emitir instruções verbais para a TV ao pressionar o botão do microfone do controlo remoto da sua TV.
                        </li>
                        <p>
                            Se utilizar a AVS, a sua TV recolhe a sua voz e envia-a para a Amazon Alexa Cloud para reconhecimento de voz e tratamento posterior. Os seus dados serão diretamente transferidos para a Amazon e nenhum dado será armazenado localmente na sua TV. Por favor consulte a política de privacidade da Amazon para mais informações relativamente ao tratamento dos seus dados por parte da Amazon.
                        </p>
                        <p>
                            Quando utiliza a AVS, será solicitado o nome da sua TV por forma a permitir-nos encontrar a TV que pretende controlar.
                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é a execução de um contrato, nos termos Artigo 6 (1) b) do RGPD.
                        </p>
                        <p>
                            Mais, iremos registar com que frequência e durante quanto tempo utilizou a AVS, bem como que função utilizou no âmbito da AVS. Recolhemos esta informação para melhorar os produtos e fornecer melhores serviços de conteúdo aos utilizadores.
                        </p>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é o nosso interesse legítimo, nos termos do Artigo 6 (1) f) do RGPD. Mediante solicitação iremos fornecer informações adicionais sobre o teste de proporcionalidade.
                        </p>

                        <li>
                            Atualizações de Software: As atualizações de software fazem parte dos Serviços. Assim, cada vez que sua Smart TV for ligada, ela fornecerá o endereço IP, ID de Dispositivo, número do dispositivo, versão do software, tipo de cliente da sua Smart TV, ID do projeto (ou seja, arquivos de configuração), ID do usuário e número de série, para verificar se existem atualizações de software disponíveis, bem como disponibilizar e fornecer as atualizações de software apropriadas.
                        </li>
                        <p>
                            O fundamento jurídico para o respetivo tratamento dos seus dados pessoais é a execução de um contrato, nos termos do Artigo 6 (1) b) do RGPD.
                        </p>

                        <li>
                            Aplicação da lei: Podemos ser obrigados a fornecer dados às autoridades policiais competentes ou aos tribunais de justiça. Nessa possibilidade, apenas o faremos com sujeição a um instrumento legal vinculativo, como um mandado ou uma ordem judicial, que exige que cooperemos com as autoridades relevantes.
                        </li>
                        <p>
                            O fundamento jurídico para o respetivo tratamento é a nossa obrigação de cumprimento de obrigações jurídicas, nos termos do Artigo 6 (1) c) do RGPD.
                        </p>
                    </ul>

                    <p>
                        A utilização dos Serviços através de pseudónimos é possível, a menos que serviços específicos exijam que o utilizador forneça o seu nome e / ou endereço de e-mail.
                    </p>

                    <h3>
                        5. Privacidade e segurança de crianças menores de 16 anos
                    </h3>
                    <p>
                        Entendemos a importância de tomar precauções extra para proteger a privacidade e a segurança de crianças que utilizem os nossos Serviços. Crianças menores de 16 anos, ou idade mínima equivalente na jurisdição relevante, não estão autorizadas a fornecer as suas informações pessoais por meio do aparelho de TV ou quando ligarem para o serviço pós-venda, a menos que seus pais forneçam consentimento verificável.
                    </p>
                    <p>
                        Visto que nunca recolhemos datas de nascimento de utilizadores, não podemos identificar a idade destes. Mas, se soubermos que recolhemos as informações pessoais de uma criança menor de 16 anos, ou idade mínima equivalente, dependendo da jurisdição, fora das circunstâncias acima, tomaremos medidas para excluir as informações o mais rápido possível.
                    </p>

                    <h3>
                        6. Aplicações de Terceiros
                    </h3>
                    <p>
                        A sua Smart TV permite o uso de aplicações fornecidos por terceiros, como a Netflix, YouTube ou HbbTV (serviço de botão vermelho fornecido pelas emissoras de TV). O utilizador pode baixar as aplicações da loja de aplicações ou ativar aplicações de terceiros que já estão pré-instaladas no seu dispositivo. Nenhumas das aplicações de terceiros pré-instaladas no seu dispositivo recolhem dados pessoais sem o seu consentimento prévio. Por exemplo, a Netflix já está pré-instalada no dispositivo, mas apenas recolhe dados quando o utilizador entra na sua conta Netflix. O HbbTV apenas recolhe dados quando o utilizador consente com a recolha, ao pressionar o botão designado no seu comando.
                    </p>
                    <p>
                        Se o utilizador ativar uma aplicação de terceiros, os seus dados pessoais poderão ser tratados pelo fornecedor da aplicação. Nós não somos responsáveis por tal tratamento; Por favor, consulte o aviso de privacidade da aplicação de terceiros para obter informações sobre o tratamento referente aos seus dados e quais os seus respetivos direitos.
                    </p>

                    <h3>
                        7. Categorias de Destinatários
                    </h3>
                    <p>
                        Partilhamos os seus dados pessoais, recolhidos durante a utilização dos Serviços, com terceiros que sejam parceiros de conteúdo, mas apenas se o utilizador solicitar determinado conteúdo fornecido por tais parceiros de conteúdo, ou com fornecedores de serviços como responsáveis por tratamento de dados que nos auxiliam no fornecimento dos Serviços.
                    </p>
                    <p>
                        Partilhamos os seus dados pessoais com terceiros apenas se formos obrigados a fazê-lo com base em requisitos legais (por exemplo, para tribunais ou autoridades de ação penal), se o utilizador tiver consentido com o respetivo compartilhamento ou se o compartilhamento for legal nos termos aplicáveis pela lei.
                    </p>

                    <h3>
                        8. Países nos quais os seus dados serão tratados
                    </h3>
                    <p>
                        Nós e / ou alguns dos destinatários dos seus dados pessoais enunciados acima, podemos estar localizados fora do Espaço Económico Europeu (por exemplo, na República Popular da China ou nos Estados Unidos da América). Assim, os seus dados pessoais podem ser tratados em países onde as leis de proteção de dados podem fornecer um nível diferente de proteção em comparação com as leis na sua jurisdição e que não são reconhecidos como fornecendo um nível adequado de proteção de dados pessoais de acordo com o RGPD. Os países que fornecem um nível adequado de proteção de dados, numa perspetiva da legislação europeia de proteção de dados, incluem Andorra, Argentina, Canadá, Suíça, Ilhas Faroé, Guernsey, Estado de Israel, Ilha de Man, Jersey, Nova Zelândia e a República Oriental do Uruguai. Os destinatários nos EUA podem ser parcialmente certificados pelo Escudo de Privacidade UE-EUA e, portanto, reconhecidos como fornecendo um nível adequado de proteção de dados do ponto de vista da legislação europeia de proteção de dados.
                    </p>
                    <p>
                        Quando necessário, implementaremos salvaguardas apropriadas com relação às transferências de dados para destinatários fora da União Europeia que não forneçam um nível adequado de proteção de dados. Uma cópia da medida respetiva pode ser solicitada, contactando-nos, como indicado na Seção 12 abaixo.
                    </p>

                    <h3>
                        9. Prazo de Conservação
                    </h3>
                    <p>
                        Os seus dados pessoais serão conservados pelo tempo necessário para fornecer os Serviços. Para a maioria dos dados, isto geralmente significa que conservaremos os seus dados por um mês. Para fins de diagnóstico remoto e serviços pós-venda, podemos conservar os seus dados até dez anos. Quando já não precisarmos de utilizar os seus dados pessoais para cumprir obrigações contratuais ou legais, removeremos os mesmos dos nossos sistemas, registos e / ou tomaremos os passos necessários para os tornar anónimos, para que não possa continuar a ser identificado a partir deles.
                    </p>

                    <h3>
                        10. Os seus direitos
                    </h3>
                    <p>
                        De acordo com a lei de proteção de dados aplicável, o utilizador pode ter o direito de: solicitar acesso aos seus dados pessoais, solicitar a retificação dos seus dados pessoais; solicitar o apagamento dos seus dados pessoais, solicitar a restrição de tratamento dos seus dados pessoais; solicitar a portabilidade de dados e fazer objeções ao tratamento dos seus dados pessoais. Note-se que estes direitos mencionados podem ser limitados pela lei nacional de proteção de dados aplicável. Para mais informações sobre estes direitos, por favor, consulte o Anexo: Os seus Direitos, que se encontra abaixo.
                    </p>
                    <p>
                        O utilizador também tem o direito de apresentar uma queixa junto à autoridade de controlo de proteção de dados competente.
                    </p>
                    <p>
                        Para exercer os seus direitos, entre em contacto connosco, conforme indicado na Seção 12 abaixo.
                    </p>

                    <h3>
                        11. Alterações ao Aviso de Privacidade
                    </h3>
                    <p>
                        Para melhorar os nossos Serviços, podemos necessitar de efetuar alterações a este Aviso de Privacidade - por exemplo, pela implementação de novas tecnologias ou pela introdução de novos serviços. Reservamo-nos o direito de alterar ou complementar este Aviso de Privacidade a qualquer momento.
                    </p>

                    <h3>
                        12. Informações de contacto
                    </h3>
                    <p>
                        Se tiver alguma dúvida sobre o Aviso de Privacidade ou desejar reclamar sobre o tratamento dos seus dados pessoais, entre em contacto connosco usando os seguintes detalhes de contacto:
                    </p>
                    <p>
                        Formulário de contacto: www.tcl.eu/en/contact-us
                    </p>
                    <p>
                    </p>
                    <p>
                        Version: 2.0
                    </p>
                    <br>

                    <div class="stage__text">
                        <h1 class="tl1">
                            Anexo: Os seus direitos
                        </h1>
                    </div>
                    <ul>
                    <li>
                        a. Direito de acesso: Pode ter o direito de obter, da nossa parte, a confirmação se os seus dados pessoais são ou não tratados e, onde for o caso, solicitar acesso aos dados pessoais. A informação de acesso inclui - nomeadamente - os motivos do tratamento, as categorias de dados pessoais em questão e os destinatários ou categorias de destinatários para os quais os dados pessoais foram ou serão divulgados. No entanto, isto não é um direito absoluto e os interesses de outros indivíduos podem restringir o seu direito de acesso.
                    </li>
                    <p>
                        Pode ter o direito de obter uma cópia dos dados pessoais que estão a ser tratados. Para cópias adicionais solicitadas por si, poderemos cobrar uma taxa razoável calculada com base nos custos administrativos.
                    </p>
                    <li>
                        b.	Direito à retificação: Pode ter o direito de obter, da nossa parte, a retificação de dados pessoais inexatos que lhe digam respeito. Dependendo dos motivos do tratamento, pode ter direito a que os seus dados pessoais incompletos sejam completados, incluindo por meio de uma declaração adicional.
                    </li>
                    <li>
                        c.	Direito ao apagamento ("direito a ser esquecido"): Sob certas circunstâncias, o titular pode ter o direito de obter do responsável do tratamento o apagamento dos seus dados e este tem a obrigação de apagar os dados pessoais em causa.
                    </li>
                    <li>
                        d.	Direito à limitação do tratamento: Sob certas circunstâncias, o titular dos dados pode ter o direito de exigir a limitação do tratamento dos seus dados pessoais. Neste caso, os respetivos dados serão marcados e só poderão ser tratados por nós para determinados motivos.
                    </li>
                    <li>
                        e.	Direito de portabilidade de dados: Sob certas circunstâncias, o titular dos dados pode ter o direito de receber os dados pessoais que nos forneceu, num formato estruturado, de uso corrente e de leitura automática, e o direito de transmitir esses dados a outro responsável pelo tratamento sem que o responsável a quem os dados pessoais foram fornecidos o possa impedir.
                    </li>
                    <li>
                        f.	Direito de oposição: Sob certas circunstâncias, o titular dos dados pode ter o direito de se opor a qualquer momento, por motivos relacionados com a sua situação particular, ou quando os dados pessoais forem tratados para efeitos de comercialização direta, para que paremos o tratamento dos seus dados pessoais.
                    </li>
                    <p>
                        Adicionalmente, se os seus dados pessoais forem tratados para fins de comercialização direta, o titular dos dados tem o direito de se opor a qualquer momento ao tratamento de dados pessoais que lhe digam respeito para essa comercialização, incluindo a definição de perfis com base nessa comercialização direta. Nesse caso, os seus dados pessoais não continuarão a ser tratados por nós.
                    </p>
                    </ul>
                    <br>
                    <br>

                    <div class="stage__text">
                        <h1 class="tl1">
                            Aviso de cookies - Serviços Smart TV
                        </h1>
                    </div>
                    <p>
                        Respeitamos a sua privacidade ao utilizar as Smart TVs e os nossos Serviços. Os cookies são utilizados por muitos sites e outros serviços da Internet, e a sua Smart TV aceita, armazena e transmite cookies para garantir que esses sites e serviços funcionam corretamente.
                    </p>
                    <p>
                        Não usamos cookies ao fornecer-lhe os Serviços. No entanto, terceiros (por exemplo, fornecedores de aplicações) podem utilizar cookies quando usa a Smart TV para aceder aos seus serviços. Este Aviso de Cookies só pode fornecer informações limitadas sobre cookies que podem ser inseridas por terceiros. Para obter informações sobre os cookies realmente utilizados por terceiros e as suas funcionalidades, recomendamos a leitura dos respetivos avisos de cookies desses terceiros. Todavia, neste Aviso de Cookies, fornecemos uma descrição geral de quais cookies podem ser definidos na sua Smart TV e como pode geri-los.
                    </p>
                    <h3>
                        1. O que é um cookie?
                    </h3>
                    <p>
                        Cookies são pequenos ficheiros de texto que podem ser inseridos na sua Smart TV. Quando um site ou o serviço de botão vermelho de um canal de TV é acedido, o site ou serviço pode armazenar um cookie na Smart TV. Durante acessos posteriores, uma cookie inserida na sua Smart TV enviará informações para a parte que colocou o cookie. Os cookies são extremamente comuns e usados em vários sites e serviços. Cada cookie tipicamente contém o nome do domínio do qual proveio, a "vida" da cookie e um valor (geralmente um número único). Para uma explicação mais detalhada sobre o que são os cookies e como operam, visite www.allaboutcookies.org.
                    </p>
                    <p>
                        Os cookies podem ser classificados como cookies funcionais e não funcionais. Os cookies funcionais são cookies estritamente necessários para lhe fornecer serviços. Cookies não funcionais são todos os outros cookies.
                    </p>
                    <h3>
                        2. Sites de terceiros
                    </h3>
                    <p>
                        Quando visita sites ou serviços de terceiros por meio dos Serviços da sua Smart TV, é possível que tais sites ou serviços coloquem cookies na sua Smart TV, e que rastreiem e armazenem as suas interações nesses sites. Não solicitamos ou incentivamos tais atividades e não utilizaremos estas informações. Por favor, consulte o respetivo cookie e os avisos de privacidade de tais sites e serviços, de modo a obter mais informações sobre a utilização por terceiros dos referidos cookies.
                    </p>
                    <h3>
                        3. Remoção de cookies
                    </h3>
                    <p>
                        O interface de utilizador da sua Smart TV permite apagar todos os cookies e outros armazenamentos locais do navegador da Smart TV. É altamente recomendável remover todos os cookies e configurações armazenadas localmente, antes de vender ou oferecer a sua Smart TV.
                    </p>
                    <p>
                        Version: 2.0
                    </p>
                </div>
            </section>
        </main>

        <footer class="mainFooter">
            <p> © 2018 TCL Inc. </p>
        </footer>
    </div>
</template>

<script>
export default {
    name: "PrivacyPolicy"
}
</script>

<style scoped>
.privacyPage h3 {
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 25px;
    font-family: 'opensans_regular', sans-serif;
    font-size: 1.2em;
    font-size: 1.2rem;
    font-weight: normal;
    color: #262626;
    line-height: 1.25em;
}

p,
ul li {
    font-size: 0.92em;
    font-size: 0.92rem;
}

.privacyPage section {
    font: 1.2em/1.6em 'opensans_regular', sans-serif;
    color: #666;
    background-color: #FFF;
    line-height: 1.25em;
}

.privacyPage .mainHeader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 54px;
    z-index: 999;
    background-color: #0d0d0d;
    transition: top 0.3s;
}

.privacyPage .mainHeader__inner {
    display: table;
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    padding: 0 30px;
}

.privacyPage .mainCenter {
    max-width: 1276px;
    padding: 30px;
    padding-top: 60px;
    margin: 0 auto;
}


.privacyPage .mainContent__center {
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    overflow: hidden;
}

.privacyPage .mainHeader__logo {
    position: relative;
    width: 105px;
    height: 55px;
    overflow: hidden;
}

.privacyPage .mainContent__center {
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    overflow: hidden;
}

.privacyPage .stage {
    position: relative;
    padding: 30px 0;
    min-height: 330px;
}

.stage__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.view {
    padding-top: 54px;
}

footer {
    margin: 2rem auto;
    text-align: center;
}


/* .mainHeader__logo, .mainHeader__nav {
    display: table-cell;
    height: 100%;
    vertical-align: middle;
} */
</style>




// WEBPACK FOOTER //
// src/pages/PrivacyPolicy_BR.vue